import {isDevMode} from '@angular/core';
import {authGuard, isDevGuard, LegacyRedirectMatcher, LoginMatcher, PermissionsGuard, PWAGuard} from '@auth/data-access';
import {PermissionType, UserRoleType, ValidationType} from '@core/api/data-access';
import {GlobalAppRoute, globalAppRouteConfigFactory} from '@global-data';
import {canActivateValidation, onFailValidationNavTo} from '@validations/data-access';

// new
export const appRoutes: GlobalAppRoute[] = [
	{
		path: 'login',
		canMatch: [LegacyRedirectMatcher(), LoginMatcher()],
		loadChildren: () => import('@auth/feature-auth').then(m => m.authFeatureAuthRoutes),
	},
	{
		path: 'redirect',
		canActivate: [],
		data: globalAppRouteConfigFactory({autoHideSidenav: true}),
		loadComponent: () => import('@auth/feature-auth').then(m => m.RedirectLoginComponent),
	},

	{
		path: 'build-in-forms',
		loadChildren: () => import('@forms/build-in-forms').then(m => m.featureBuildInFormsRoutes),
	},
	// Sign Landing Pages
	{
		path: 'sign-landing',
		canMatch: [
			() => {
				debugger;
				return true;
			},
		],
		loadChildren: () => import('@cycles/sign/landing-pages').then(m => m.signLandingPagesRoutes),
	},
	{
		path: 'sign',
		loadChildren: () => import('@cycles/sign/feature-sign').then(m => m.featureSignRoutes),
	},
	{
		path: 'fast-sign',
		loadChildren: () => import('@cycles/sign/fast-signing').then(m => m.featureFastSigningRoutes),
	},
	{
		path: 'validations',
		canActivate: [authGuard()],
		children: [
			{
				path: 'liveness',
				canActivate: [canActivateValidation(ValidationType.Liveness, onFailValidationNavTo)],
				loadChildren: () => import('@validations/liveness/feature-liveness').then(m => m.featureLivenessRoutes),
				data: globalAppRouteConfigFactory({autoHideSidenav: true}),
			},
			{
				path: 'face-match',
				canActivate: [canActivateValidation(ValidationType.FaceMatch, onFailValidationNavTo)],
				loadChildren: () => import('@validations/face-match/feature-face-match').then(m => m.featureFaceMatchRoutes),
				data: globalAppRouteConfigFactory({autoHideSidenav: true}),
			},
			{
				path: 'document-reader',
				canActivate: [canActivateValidation(ValidationType.DocumentVerification, onFailValidationNavTo)],
				loadChildren: () => import('@validations/document-reader/feature-document-reader').then(m => m.featureDocumentReaderRoutes),
				data: globalAppRouteConfigFactory({autoHideSidenav: true}),
			},
		],
	},

	{
		path: 'cw',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.cycle_create])],
		loadChildren: () => import('@cycles/creation-wizard/feature-creation-wizard-main').then(m => m.featureCreationWizardRoutes),
	},
	{
		path: 'home',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.permanent], {fallbackLogout: true}), PWAGuard],
		loadChildren: () => import('@feature-dashboard').then(m => m.featureHomeRoutes),
	},
	{
		path: 'swagger-ui',
		canActivate: [
			authGuard({reAuthenticate: true}),
			PermissionsGuard(isDevMode() || location.hostname.includes('.dev') ? [PermissionType.admin, UserRoleType.Superuser] : [PermissionType.admin], {fallbackRoute: 'home'}),
		],
		loadChildren: () => import('@dev-tools/swagger').then(m => m.featureSwaggerRoutes),
	},
	{
		path: 'dev-panel',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.permanent, PermissionType.users_manage], {fallbackRoute: 'home'})],
		loadChildren: () => import('@dev-tools/panel').then(m => m.featureDevPanelRoutes),
	},
	{
		path: 'status',
		loadComponent: () => import('@dev-tools/app-status').then(m => m.AppStatusComponent),
	},
	{
		path: 'dev-demo-page',
		canActivate: [isDevGuard],
		loadComponent: () => import('@dev-tools/demo-page').then(m => m.DevDemoPageComponent),
	},
	{
		path: 'users',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.permanent], {fallbackRoute: 'home'})],
		loadChildren: () => import('@feature-users-table').then(m => m.featureUsersTableRoutes),
	},
	{
		path: 'company-settings',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.users_manage], {fallbackRoute: 'home'})],
		loadChildren: () => import('@company-settings/company-settings').then(m => m.featureCompanySettingsRoutes),
	},
	{
		path: 'cycles',
		canActivate: [authGuard({reAuthenticate: true}), PermissionsGuard([PermissionType.permanent], {fallbackRoute: 'home'})],
		loadChildren: () => import('@cycles/cycle-tables').then(m => m.featureCycleTablesRoutes),
	},
	{
		path: 'cycle-activity',
		canActivate: [authGuard({reAuthenticate: true})],
		loadChildren: () => import('@cycles/features/cycle-log-chat').then(m => m.cycleActivityRoutes),
	},
	{
		path: 'sent-mailing-list',
		canActivate: [authGuard({reAuthenticate: true})],
		loadChildren: () => import('@cycles/forms/sent-mailing-documents-list').then(m => m.featureSentMailingDocumentsListRoutes),
	},

	{
		path: 'app',
		canActivate: [authGuard({reAuthenticate: true})],
		loadChildren: () => import('@app-forms/feature-app-forms').then(m => m.featureAppFormsRoutes),
	},
	{
		path: 'app-reset/:redirectUrl/:afterForceReload',
		canActivate: [],
		loadComponent: () => import('./app-reset/app-reset.component').then(m => m.AppResetComponent),
		data: globalAppRouteConfigFactory({autoHideSidenav: true}),
	},
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: 'login',
		pathMatch: 'full',
	},
];
